import { Button } from "@dash/form";
import { Card, Header4 } from "@dash/page";
import React from "react";
import { MdDownload, MdUpload } from "react-icons/md";
import { useNavigate } from "react-router-dom-v5-compat";

export const ItemSyncOptionsBar: React.FunctionComponent = (props) => {
  const navigate = useNavigate();

  return (
    <div css={{ display: "flex", gap: "1rem", flexDirection: "row", alignItems: "center", flexWrap: "wrap" }}>
      <OptionCard label="Google Sheets">
        <Button
          variant="outline"
          icon={<MdDownload />}
          onClick={() => navigate(`/crm/items/import?options={"googleSheets": {"spreadsheetId": ""}}`)}
          size="small"
          css={{ padding: "0.5rem" }}
        >
          Importuj
        </Button>

        <Button
          variant="outline"
          icon={<MdUpload />}
          onClick={() => navigate(`/crm/items/export?options={"googleSheets": {}}`)}
          size="small"
          css={{ padding: "0.5rem" }}
        >
          Eksportuj
        </Button>
      </OptionCard>
      <OptionCard label="Business Central">
        <Button
          variant="outline"
          icon={<MdDownload />}
          onClick={() => navigate(`/crm/items/import?options={"bc": {}}`)}
          size="small"
          css={{ padding: "0.5rem" }}
        >
          Importuj
        </Button>

        <Button
          variant="outline"
          icon={<MdUpload />}
          onClick={() => navigate(`/crm/items/exportBcItems`)}
          size="small"
          css={{ padding: "0.5rem" }}
        >
          Eksportuj
        </Button>
      </OptionCard>
      <OptionCard label="Shopify">
        <Button
          variant="outline"
          icon={<MdDownload />}
          onClick={() => navigate(`/crm/items/import?options={"shopify": {}}`)}
          size="small"
          css={{ padding: "0.5rem" }}
        >
          Importuj
        </Button>

        <Button
          variant="outline"
          icon={<MdUpload />}
          onClick={() => navigate(`/crm/items/exportShopifyProducts`)}
          size="small"
          css={{ padding: "0.5rem" }}
        >
          Produkty
        </Button>
        <Button
          variant="outline"
          icon={<MdUpload />}
          onClick={() => navigate(`/crm/items/exportShopifyVariants`)}
          size="small"
          css={{ padding: "0.5rem" }}
        >
          Warianty
        </Button>
      </OptionCard>
      <OptionCard label="Payload CMS">
        <Button
          variant="outline"
          icon={<MdDownload />}
          onClick={() => navigate(`/crm/items/import?options={}`)}
          size="small"
          css={{ padding: "0.5rem" }}
        >
          Importuj
        </Button>

        <Button
          variant="outline"
          icon={<MdUpload />}
          onClick={() => navigate(`/crm/items/export?options={}`)}
          size="small"
          css={{ padding: "0.5rem" }}
        >
          Eksportuj
        </Button>
      </OptionCard>
    </div>
  );
};

const OptionCard = (props: { label: string; children?: React.ReactNode }) => {
  return (
    <Card
      variant="secondary"
      css={{ flexDirection: "column", justifyContent: "space-between", flexGrow: 0, gap: "1rem" }}
    >
      <Header4>{props.label}</Header4>
      <div css={{ display: "flex", gap: "0.5rem", alignItems: "center" }}>{props.children}</div>
    </Card>
  );
};
